import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import _some from 'lodash/some';
import { setLoading } from '../redux/app/appSlice';

const useLoading = (loadingConditions) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const loading = _some(loadingConditions, (lc) => lc === true);
    if (loading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [dispatch, loadingConditions]);
  return useEffect;
};

export default useLoading;
